import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { CouponReveal } from "@/components/CouponReveal";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useLang } from "@/lib/i18n";

export default function Kupong() {
  const { token } = useParams();
  const { t } = useLang();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api
      .get(`/coupon/${token}`)
      .then((res) => setData(res.data))
      .catch((err) => setError(formatApiErrorDetail(err.response?.data?.detail)));
  }, [token]);

  if (error || (data && data.utlopt)) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-[#1A1715] px-6 text-center">
        <Logo />
        <p className="text-[#A8A29E]" data-testid="coupon-error">
          {error || t("Denne kupongen er dessverre utløpt.", "Unfortunately this coupon has expired.")}
        </p>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#1A1715] text-[#A8A29E]">{t("Laster…", "Loading…")}</div>
    );
  }

  return (
    <CouponReveal
      tittel={t(data.tittel, data.tittel_en || data.tittel)}
      fornavn={data.fornavn}
      utloper={data.utloper}
      aktivert={data.aktivert}
      innlost={data.innlost}
      heading={`${t("Hei", "Hi")}${data.fornavn ? `, ${data.fornavn}` : ""}! ❤️`}
      subheading={t("Vi har en liten hilsen til deg.", "We have a little treat for you.")}
      onActivate={async () => (await api.post(`/coupon/${token}/activate`)).data}
      onRedeem={async () => (await api.post(`/coupon/${token}/redeem`)).data}
    />
  );
}
